import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteAccountModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteAccountModalContainer" */
      './DeleteAccountModalContainer'
    ),
  loading: LoadingModal,
});
